<template>
    <div class="text-center">
      <v-dialog persistent v-model="visible" width="800">
        <v-card class="not-margin pt-0 pr-0 pl-0">
          <v-toolbar dark color="primary">
            <div class="text-center">
              <v-icon>mdi-eye</v-icon> Visualizar Turma
            </div>
          </v-toolbar>
          <div class="container dialog">
            <v-form ref="form">
              <v-row class="d-flex justify-center mt-7">
                <v-col cols="12">
                    <v-text-field
                    label="Nome da Turma*"
                    v-model="content.nome"
                    outlined
                    dense
                    disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-select
                    v-model="content.anoLetivo"
                    label="Ano Letivo*"
                    item-text="ano"
                    item-value="id"
                    outlined
                    dense
                    :items="lists.listAnosLetivos"
                    disabled
                    ></v-select>
                </v-col>
                <v-col cols="4">
                    <v-select
                    v-model="content.serie"
                    label="Ano/Serie*"
                    item-text="nome"
                    item-value="id"
                    outlined
                    dense
                    :items="lists.listAnoSeries"
                    disabled
                    ></v-select>
                </v-col>
                <v-col cols="4">
                    <v-select
                    v-model="content.turno"
                    label="Turno*"
                    item-text="descricao"
                    item-value="id"
                    outlined
                    dense
                    :items="lists.listTurnos"
                    disabled
                    ></v-select>
                </v-col>
                <v-col cols="6">
                <v-select
                  v-model="content.municipio"
                  label="Município*"
                  item-text="nome"
                  item-value="id"
                  outlined
                  dense
                  :items="lists.listMunicipios"
                  disabled
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="content.escola"
                  label="Escola*"
                  item-text="local"
                  item-value="id"
                  outlined
                  dense
                  :items="lists.listEscolas"
                  disabled
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="content.professorPortugues"
                  label="Professor(a) de Língua Portuguesa*"
                  item-text="nome"
                  item-value="id"
                  outlined
                  dense
                  :items="lists.listProfessor"
                  disabled
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="content.professorMatematica"
                  label="Professor(a) de Matemática*"
                  item-text="nome"
                  item-value="id"
                  outlined
                  dense
                  :items="lists.listProfessor"
                  disabled
                ></v-select>
              </v-col>

            <v-col cols="4">
                <v-text-field
                label="Quantidade de Alunos*"
                v-model="content.quantidadeAlunos"
                outlined
                dense
                disabled
                ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <div class="btn-group text-center">
            <v-btn color="primary" @click="$emit('onClose')">
              <v-icon>mdi-close</v-icon>
              Fechar
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import { DialogProps } from '~/commons/classes/dialog-props';
import { Turma } from '~/commons/classes/turma';
  
  export default {
    props: {
    ...new DialogProps(Turma),
    lists: {
      type: Object,
    },
  },
  };
  </script>
  